import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    children: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

/* Small uppercase section identifier, for example "WHAT WE DO / 01". */
export const SectionLabel: FC<SectionLabelProps> = ({ children, tone = 'light', className }): ReactNode => {
    return (
        <p
            className={cn(
                'flex items-center gap-3 font-mono text-[11px] font-medium uppercase tracking-[0.22em]',
                tone === 'dark' ? 'text-cream/75' : 'text-charcoal/80',
                className
            )}
        >
            <span aria-hidden='true' className='size-2 shrink-0 bg-coral' />
            {children}
            <span aria-hidden='true' className='h-px w-10 bg-current opacity-40' />
        </p>
    )
}
